/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContentGraphActorEdge = zod.object({
  audience: zod.object({
    principalType: zod.enum([
      'USER',
      'GROUP',
      'GROUP_MEMBERS',
      'GROUP_MEMBER',
      'PUBLIC',
      'SYSTEM',
      'AGENT',
    ]),
    scopeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
    uuid: zod.uuid().describe('UUID v4 identifier'),
  }),
  contentUuid: zod.uuid().describe('UUID v4 identifier'),
  createdAt: zod.string(),
  creator: zod.object({
    principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER', 'SYSTEM', 'AGENT']),
    scopeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
    uuid: zod.uuid().describe('UUID v4 identifier'),
  }),
  edgeType: zod.enum(['AUTHORED_BY', 'SHARED_WITH']),
  expiry: zod.string().nullable(),
  permissions: zod
    .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
    .describe(
      'Permissions this audience holds on this ONE node. Per node and per audience — never a summary of what the reader may do to the graph.',
    ),
  updatedAt: zod.string(),
});

export type ContentGraphActorEdge = zod.input<typeof ContentGraphActorEdge>;
export type ContentGraphActorEdgeOutput = zod.output<typeof ContentGraphActorEdge>;
